const socialIconsData  = [
  {
    url: "https://wa.me/yourwhatsapplink",
    network: "whatsapp",
    bgColor: "#25D366",
  },
  {
    url: "https://facebook.com",
    network: "facebook",
    bgColor: "#1877F2",
  },
  {
    url: "https://twitter.com",
    network: "twitter",
    bgColor: "#1DA1F2",
  },
  {
    url: "https://instagram.com",
    network: "instagram",
    bgColor: "#E1306C",
  },
  {
    url: "https://linkedin.com",
    network: "linkedin",
    bgColor: "#0077B5",
  },
];

export default socialIconsData;